module.exports = __webpack_public_path__ + "img/live_chat_banner.6de9f65.png";